// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__MK201","footer":"ModalInfo_footer__n7Q3W"};